import "../../styles/pages/GetStarted.scss";
import { Link } from "react-router-dom";
import React, { useState } from "react";

export default function GetStarted() {
  const [getStarted, setGetstarted] = useState(false);
  function toggleVisible() {
    setGetstarted(getStarted);
  }
  const auth = JSON.parse(sessionStorage.getItem("user"));
  return (
    <Link to="/register" onClick={toggleVisible}>
      {auth ? (
        <div></div>
      ) : (
        <>
          <div className="container-button">
            <div className="btn-button">
              <div className="shop-now">Get Started</div>
              <div className="snowflake-grid to-left">
                <div className="snowflake-item border-bottom border-right">
                  <div className="sub-items border-right border-bottom pull-down">
                    <div className="m-w-15 m-h-15 border-right border-bottom m-3"></div>
                  </div>
                </div>
                <div className="snowflake-item border-bottom border-left">
                  <div className="sub-items border-right border-bottom r-90 pull-down-right">
                    <div className="m-w-15 m-h-15 border-right border-bottom m-3"></div>
                  </div>
                </div>
                <div className="snowflake-item border-top border-right">
                  <div className="sub-items border-right border-bottom r-270 pull-right">
                    <div className="m-w-15 m-h-15 border-right border-bottom m-3"></div>
                  </div>
                </div>
                <div className="snowflake-item border-top border-left">
                  <div className="sub-items border-right border-bottom r-180 pull-left">
                    <div className="m-w-15 m-h-15 border-right border-bottom m-3"></div>
                  </div>
                </div>
              </div>
              <div className="snowflake-grid to-right">
                <div className="snowflake-item border-bottom border-right">
                  <div className="sub-items border-right border-bottom pull-down">
                    <div className="m-w-15 m-h-15 border-right border-bottom m-3"></div>
                  </div>
                </div>
                <div className="snowflake-item border-bottom border-left">
                  <div className="sub-items border-right border-bottom r-90 pull-down-right">
                    <div className="m-w-15 m-h-15 border-right border-bottom m-3"></div>
                  </div>
                </div>
                <div className="snowflake-item border-top border-right">
                  <div className="sub-items border-right border-bottom r-270 pull-right">
                    <div className="m-w-15 m-h-15 border-right border-bottom m-3"></div>
                  </div>
                </div>
                <div className="snowflake-item border-top border-left">
                  <div className="sub-items border-right border-bottom r-180 pull-left">
                    <div className="m-w-15 m-h-15 border-right border-bottom m-3"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </Link>
  );
}
